import React from "react";
import LegalLayout from "../LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout testid="mentions-page" eyebrow="Légal" title="Mentions légales" lastUpdate="14 octobre 2026">
      <h2>Acta Documentum — Projet Ego Automata</h2>
      <p>
        Acta Documentum est une application développée dans le cadre du projet entrepreneurial
        <strong> Ego Automata</strong>, actuellement en cours de création.
      </p>
      <p>
        L'application est utilisée dans le cadre d'un test privé par des salariés et prestataires
        travaillant pour <strong>LIRAH SAS</strong>, avec des données professionnelles réelles.
        Alma France est un projet de société non encore constituée.
      </p>
      <p>
        Les informations juridiques et relatives à la protection des données personnelles
        sont en cours de mise à jour.
      </p>
      <p>
        L'application est actuellement éditée par son développeur en tant que personne physique,
        dans l'attente de la création éventuelle d'Ego Automata. L'identité civile et les
        coordonnées légalement requises de l'éditeur doivent être complétées avant de
        considérer ces mentions comme définitives.
      </p>
      <h2>Hébergement</h2>
      <p>Les frais d'hébergement de l'application sont pris en charge par LIRAH SAS.
        Ce financement ne détermine pas, à lui seul, la qualité d'éditeur ou de responsable du traitement.</p>
      <p>Hébergeur technique indiqué pour le VPS : OVHcloud.</p>
      <h2>Contact</h2>
      <p><a href="mailto:contact@acta-documentum.fr">contact@acta-documentum.fr</a></p>
    </LegalLayout>
  );
}
